export const EVENT_LIST_TEMPLATE_NAME = 'event';
